<template>
  <div>
    <div class="card-header">
      <form class="box-search" @submit.prevent="submitForm">
        <div class="form-group">
          <DateRangePicker placeholder="Thời gian xuất bán" class="w-100" :ranges="false" @update="transformDate()"
            v-model="dateRange" :locale-data="localeData">
            <template v-slot:input="picker">
              <label v-if="picker.startDate && picker.endDate" style="min-width: 13.5em"
                class="text-center font-size-12">
                {{ picker.startDate | formatDate }} -
                {{ picker.endDate | formatDate }}
              </label>
              <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                Từ ngày - Đến ngày
              </label>
            </template>
          </DateRangePicker>
        </div>

        <div class="form-group">
          <Select2 v-model="search.agentIds" :settings="searchAgent" placeholder="Chi nhánh"></Select2>
        </div>
        <div class="form-group">
          <Select2 placeholder="Đối tác" v-model="search.partnerCode" :options="partnerCodeMap">
          </Select2>
        </div>
        <div class="form-group">
          <Select2 v-model="search.categoryCodes" :options="optionType" :settings="{ multiple: true }" placeholder="Loại thiết bị"></Select2>
        </div>
        <div class="form-group form-group-action">
          <button @click="submitForm" class="pt-2 mr-2 btn btn-primary hc-37" data-toggle="tooltip" data-placement="top"
            title="Lọc">
            <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
          </button>
          <button @click="resetFilters" type="button" class="pt-2 mr-2 btn btn-outline-light hc-37"
            data-toggle="tooltip" data-placement="top" title="Bỏ lọc">
            <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
          </button>
        </div>
      </form>
    </div>

    <div class="card-body">
      <div class="tab-content" id="nav-tabContent">
        <div class="d-flex align-items-center gap-5 my-1 total-label">
          <p>Tổng giao dịch: <span class="text-primary">{{ formatQuantity(countList?.totalTransaction ?? 0) || 0 }}</span></p>

          <p>Tổng số tiền: <span class="text-primary">{{ formatCurrency(countList?.totalAmount ?? 0) || 0 }}</span></p>
          <p>Tổng thiết bị đã nhập: <span class="text-primary">{{ formatQuantity(countList?.totalDeviceImport ?? 0) || 0 }}</span></p>
          <p>
            Tổng thiết bị đang hoạt động: <span class="text-primary">{{ formatQuantity(countList?.totalDeviceActive ?? 0) || 0 }}</span>
          </p>
        </div>

        <div class="p-0">
          <b-table :busy.sync="loading" sticky-header hover responsive :items="tableDataWithTotal" :fields="tableFields"
            :fixed="true" :bordered="true">
            <template #table-busy>
              <div class="my-2 text-center">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(index)="data">
              {{ getIndex(data.index) }}
            </template>
            <template #cell(name)="{ item }">
              <p>{{ item?.agentName }}</p>
              <p>{{ item?.agentEmail }}</p>
            </template>
            <template #cell(transactionCount)="{ item }">
              {{ formatQuantity(item?.totalTransaction) }}
            </template>
            <template #cell(transactionAmount)="{ item }">
              {{ formatCurrency(item?.totalAmount) }}
            </template>
            <template #cell(importedDevices)="{ item }">
              {{ formatQuantity(item?.totalDeviceImport) }}
            </template>
            <template #cell(activatedDevices)="{ item }">
              {{ formatQuantity(item?.totalDeviceActive) }}
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination v-model="pagination.page" :total-rows="pagination.total" :per-page="pagination.limit"
        @change="onChangePage" class="fl-right mr-2"></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Config from '@/thirdParty/config'
import { ReportService } from '@/services/report.service'
import { CommonService } from '@/services/common.service'
import { DeviceService } from '@/services/device.service'

export default {
  name: 'TotalByBranch',
  data () {
    return {
      partnerCodeMap: [],
      loading: false,
      search: {},
      dateRange: {
        startDate: null,
        endDate: null
      },
      pagination: {
        total: 0,
        limit: 20,
        page: 1
      },
      optionType: [],
      countList: {},
      localeData: Config.localeData,
      tableFields: [
        { key: 'index', label: 'STT', class: 'text-center', thStyle: { width: '80px' }, tdStyle: { width: '80px' } },
        { key: 'name', label: 'Chi nhánh' },
        { key: 'transactionCount', label: 'Số lượng giao dịch' },
        { key: 'transactionAmount', label: 'Số tiền giao dịch' },
        { key: 'importedDevices', label: 'Số thiết bị nhập' },
        { key: 'activatedDevices', label: 'Số thiết bị kích hoạt' }
      ],
      tableData: [],
      searchAgent: {
        placeholder: 'Tìm kiếm chi nhánh',
        multiple: true,
        ajax: {
          delay: 500,
          transport: (params, success, failure) => {
            const txtSearch = params.data?.q?.trim() || ''
            if (!txtSearch) {
              return success({
                results: []
              })
            }
            const keySearch = txtSearch ?? ''
            if (this.tLoadOwner) {
              clearTimeout(this.tLoadOwner)
            }
            this.tLoadOwner = setTimeout(() => {
              CommonService.getListAgentBank({
                keyword: keySearch,
                sortResultList: [
                  {
                    field: 'createdDate',
                    direction: 'DESC'
                  }
                ]
              }) // AI
                .then((res) => {
                  success({
                    results:
                      res.data?.map((item) => {
                        return {
                          id: item?.agentId,
                          text: item.name || ''
                        }
                      }) || []
                  })
                })
                .catch(failure)
            }, 500)
          }
        }
      }
    }
  },
  computed: {
    tableDataWithTotal () {
      return [...this.tableData]
    }
  },
  async created () {
    this.fetchData()
    this.fetchĐataPartner()
    this.fetchNameDevice()
  },
  methods: {
    async fetchNameDevice () { // AI
      if (!this.loading) this.showLoading = true // AI
      try { // AI
        this.loading = true // AI
        const response = await DeviceService.ListNameDevice({ // AI
          kind: 'SERIAL', // AI
          agentView: true
        }) // AI
        if (response.code === 1000) { // AI
          const filteredData = response.data || []

          // Map dữ liệu đã lọc thành định dạng yêu cầu
          this.optionType = filteredData.map((e) => ({ id: e.abbreviation, text: e.name })) || [] // AI
        } else { // AI
          this.list = [] // AI
          this.pagination.total = 0 // AI
        } // AI
      } catch (error) { // AI
        console.error('Error fetching data:', error) // AI
      }
    }, // AI
    async fetchĐataPartner () {
      try {
        const data = await CommonService.getListAgentPartner({ page: 1, limit: 1000 })
        if (data.code === 1000) {
          this.partnerCodeMap = data.data.map((item) => {
            return {
              id: item?.code,
              text: item.name || ''
            }
          }) || []
          this.partnerCodeMap.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      }
    },
    onChangePage (page) {
      this.pagination.page = page
      this.fetchData()
    },
    filterObject (obj) { // AI
      const result = {} // AI

      let hasInvalidValue = false // AI

      for (const [key, value] of Object.entries(obj)) { // AI
        if (value === null || value === '0') { // AI
          hasInvalidValue = true // AI
          continue // AI
        } // AI
        result[key] = value // AI
      } // AI

      return hasInvalidValue ? result : obj // AI
    }, // AI
    async fetchData () {
      try {
        this.loading = true
        const payload = this.filterObject(this.search)
        const res = await ReportService.getListReportByAgent({
          ...payload,
          page: this.pagination.page,
          limit: this.pagination.limit,
          isCountTotal: true
          // sortResultList: [
          //   {
          //     field: 'createdDate',
          //     direction: 'DESC'
          //   }
          // ]
        })
        this.$emit('params', {
          ...payload,
          page: this.pagination.page,
          limit: this.pagination.limit,
          isCountTotal: true
          // sortResultList: [
          //   {
          //     field: 'createdDate',
          //     direction: 'DESC'
          //   }
          // ]
        })
        if (res.code === 1000) {
          this.tableData =
            res.data?.filter((item) => item.agentName !== 'TOTAL') || []
          this.countList =
            res.data?.find((item) => item.agentName === 'TOTAL') || {}
          this.pagination.total = res.totalPage.total ?? 0
        } else {
          this.showErr(res.message)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.showErr(error.message)
      } finally {
        this.loading = false
      }
    },
    transformDate () { // AI
      if (this.dateRange.startDate && this.dateRange.endDate) { // AI
        this.search.fromDate = moment(this.dateRange.startDate) // AI
          .startOf('day') // AI
          .valueOf() // AI
        this.search.toDate = moment(this.dateRange.endDate) // AI
          .endOf('day') // AI
          .valueOf() // AI
      } else { // AI
        this.search.fromDate = null // AI
        this.search.toDate = null // AI
      } // AI
    }, // AI
    showErr (message) { // AI
      this.notiModal = true // AI
      this.iconNoti = require('@/assets/img/noti-unsuccess2.svg') // AI
      this.msgNoti = message // AI
    },
    submitForm (event) { // AI
      event.preventDefault() // AI
      // Implement filter logic here
      this.pagination.page = 1 // AI
      this.fetchData() // AI
    }, // AI
    resetFilters () { // AI
      this.search = {} // AI
      this.dateRange = { // AI
        startDate: null, // AI
        endDate: null // AI
      } // AI
      this.pagination.page = 1 // AI
      this.fetchData() // AI
    }, // AI
    formatQuantity (value) { // AI
      return value?.toLocaleString('vi-VN') // AI
    }, // AI
    formatCurrency (value) { // AI
      return value?.toLocaleString('vi-VN') + ' VND' // AI
    } // AI
  } // AI
}
</script>

<style scoped>
:deep(.box-search) {
  padding: 0 !important;
}

:deep(.card-body) {
  padding: 10px 0 !important;
}

:deep(.table tr.table-success) {
  background-color: #28a745 !important;
}

:deep(.table-success td) {
  color: white !important;
  font-weight: bold;
}
</style>
